import { render, staticRenderFns } from "./StationData.html?vue&type=template&id=654e8f48&scoped=true&external"
import script from "./StationData.vue?vue&type=script&lang=js"
export * from "./StationData.vue?vue&type=script&lang=js"
import style0 from "./StationData.scss?vue&type=style&index=0&id=654e8f48&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654e8f48",
  null
  
)

export default component.exports